// extracted by mini-css-extract-plugin
export var addToCartButton = "_ni-b";
export var arrowButtonContainer = "_ni-9";
export var arrowButtonIcon = "_ni-a";
export var carouselArrowButton = "_ni-6";
export var carouselElementContainer = "_ni-1";
export var left = "_ni-7";
export var productDisplayCarouselContainer = "_ni-0";
export var productTileContainer = "_ni-2";
export var productTileImage = "_ni-4";
export var productTileImageContainer = "_ni-3";
export var productTileTitle = "_ni-5";
export var right = "_ni-8";
export var sliderOverflow = "_ni-c";